import { FoodsIcon, IconMapping } from "@foodpilot/foods";
import { Stack, Typography, useTheme } from "@mui/material";

const PUCK_CONFIG = {
    FontFamily: "var(--puck-font-family) !important",
};

type NativePuckTitleField = {
    label: string;
    icon: keyof IconMapping;
};

export const NativePuckTitleField = (props: NativePuckTitleField) => {
    const { label = "", icon = "edit" } = props;
    const theme = useTheme();

    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={theme.spacing(0.5)}
            sx={{ mb: theme.spacing(1), pl: theme.spacing(0.5) }}
        >
            <span style={{ color: "var(--puck-color-grey-07)" }}>
                <FoodsIcon icon={icon} size={1} />
            </span>
            <Typography
                variant="subtitle2"
                sx={{
                    fontWeight: theme.typography.fontWeightBold,
                    fontFamily: PUCK_CONFIG.FontFamily,
                    mb: theme.spacing(1),
                    color: "var(--puck-color-grey-05)",
                }}
            >
                {label}
            </Typography>
        </Stack>
    );
};

export default NativePuckTitleField;
